import React, { useEffect, useRef, useState } from "react";

function SortOptionMenu({
	options = [],
	value,
	onChange,
	className = "",
	ariaLabel = "Sort options",
}) {
	const [open, setOpen] = useState(false);
	const containerRef = useRef(null);
	const defaultValue = options[0]?.value;
	const isNonDefault = defaultValue !== undefined && value !== defaultValue;

	useEffect(() => {
		if (!open) return undefined;

		const handleClickOutside = (event) => {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target)
			) {
				setOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [open]);

	const handleSelect = (nextValue) => {
		onChange?.(nextValue);
		setOpen(false);
	};

	return (
		<div ref={containerRef} className={`relative shrink-0 ${className}`.trim()}>
			<button
				type="button"
				onClick={() => setOpen((prev) => !prev)}
				aria-label={ariaLabel}
				aria-expanded={open}
				className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-600"
			>
				<svg
					className="h-4 w-4"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
					/>
				</svg>
				{isNonDefault ? (
					<span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-emerald-500" />
				) : null}
			</button>

			{open ? (
				<div className="absolute right-0 top-full z-20 mt-1.5 min-w-[140px] rounded-xl border border-slate-200 bg-white p-1 shadow-lg">
					{options.map((option) => {
						const isActive = value === option.value;
						return (
							<button
								key={option.value}
								type="button"
								onClick={() => handleSelect(option.value)}
								className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-left text-sm font-medium transition ${
									isActive
										? "bg-blue-50 text-blue-600"
										: "text-slate-700 hover:bg-slate-50"
								}`}
							>
								<span>{option.label}</span>
								{isActive ? (
									<svg
										className="h-4 w-4 shrink-0"
										fill="currentColor"
										viewBox="0 0 20 20"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fillRule="evenodd"
											d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
											clipRule="evenodd"
										/>
									</svg>
								) : null}
							</button>
						);
					})}
				</div>
			) : null}
		</div>
	);
}

export default React.memo(SortOptionMenu);
